export default [
  {
    path: '/hotelResource/hotelHome',
    component: () => import('../pages/hotelHome/index.vue'),
    name: 'HotelHome',
    meta: {
      title: '酒店',
      activeBar: 'booking'
    },
  },
  {
    path: '/hotelResource/hotelList',
    component: () => import('../pages/hotelList/index.vue'),
    name: 'HotelList',
    meta: {
      title: '酒店列表',
      activeBar: 'booking',
      isKeepAlive: true
    },
  },
  {
    path: '/hotelResource/locationSelect',
    component: () => import('../pages/locationSelect/index.vue'),
    name: 'HotelLocationSelect',
    meta: {
      title: '位置选择',
      activeBar: 'booking'
    },
  },
  {
    path: '/hotelResource/citySelect',
    component: () => import('../pages/citySelect/index.vue'),
    name: 'HotelCitySelect',
    meta: {
      title: '城市选择',
      activeBar: 'booking'
    },
  },
  {
    path: '/hotelBooking',
    component: () => import('@/hotelResource/pages/hotelBooking/index.vue'),
    name: 'HotelBooking',
    meta: {
      title: '酒店预订',
      activeBar: 'booking'
    },
  },
  // 酒店详情
  {
    path: '/hotelDetail',
    name: 'HotelDetail',
    component: () => import('@/hotelResource/pages/hotelDetail/index.vue'),
    meta: { title: '酒店详情' },
  },
  // 酒店相册
  {
    path: '/hotelAlbum',
    name: 'hotelAlbum',
    component: () => import('@/hotelResource/pages/hotelDetail/album.vue'),
    meta: { title: '酒店相册' },
  },
  // 添加入住人
  {
    path: '/hotelSelectGuest',
    name: 'hotelSelectGuest',
    component: () => import('@/hotelResource/pages/hotelBooking/hotelSelect/index.vue'),
    meta: { title: '添加入住人' },
  },
  // 编辑旅客信息
  {
    path: '/travelerEdit',
    name: 'travelerEdit',
    component: () => import('@/hotelResource/pages/hotelBooking/travelerEdit/index.vue'),
    meta: { title: '编辑入住人' },
  },
]